module.exports = __webpack_public_path__ + "static/media/hero.daf6bd09.jpg";